import { FC } from 'react';
import { SvgIconProps } from '@/types.common';

export const ExclamationMark: FC<SvgIconProps> = ({ primaryColor = '#E3AE02', onClick }) => {
	return (
		<svg
			onClick={onClick}
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="19"
			viewBox="0 0 19 19"
			fill="none">
			<path
				d="M9.5 16.625C5.56486 16.625 2.375 13.4351 2.375 9.5C2.375 5.56486 5.56486 2.375 9.5 2.375C13.4351 2.375 16.625 5.56486 16.625 9.5C16.625 13.4351 13.4351 16.625 9.5 16.625ZM8.7875 8.7875V13.0625H10.2125V8.7875H8.7875ZM8.7875 5.9375V7.3625H10.2125V5.9375H8.7875Z"
				fill={primaryColor}
			/>
		</svg>
	);
};
